import * as React from "react";
import { forwardRef } from "react";
const SvgComparisonItemPurposeFlagCurrent = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 20 20", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#5F6875", fillRule: "evenodd", d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0-1.2a5.8 5.8 0 1 0 0-11.6 5.8 5.8 0 0 0 0 11.6Z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "#5F6875", d: "M13 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" }));
const ForwardRef = forwardRef(SvgComparisonItemPurposeFlagCurrent);
export { ForwardRef as ReactComponent };
